import { UserDetails } from '@innovation-os-ng/core/models';

/**
 * Provides methods to retrieve information about users.
 */
export abstract class UserProfileServiceContract {
  /**
   * Update user and returns updated user details.
   *
   * @param userDetails updated user details.
   * @param accessToken access token.
   */
  abstract updateUserInformation(userDetails: UserDetails, accesToken: string): Promise<UserDetails>;

  /**
   * Returns user's detail.
   *
   * @param userUri The uri of the user that is to be retrived.
   */
  abstract getUser(userUri: string): Promise<UserDetails>;
}
